// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__5owk6","inner":"Form_inner__Mofjn","range":"Form_range__24zgQ","name":"Form_name__na_Oy","actions":"Form_actions__3tyRd"};